var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewGem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.01541 4.36383C4.46791 5.64016 2.34494 8.38768 1.5 11C2.73174 13.4635 7.57624 20.0802 12.7223 24.8585C13.4452 25.5297 14.5548 25.5297 15.2777 24.8585C20.4238 20.0802 25.2683 13.4635 26.5 11C25.6551 8.38768 23.5321 5.64016 21.9846 4.36383C21.6794 4.11208 21.2888 4 20.8932 4H7.10684C6.71119 4 6.32064 4.11208 6.01541 4.36383Z",
    stroke: "#FF8B3E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.51562 11H26.4922",
    stroke: "#FF8B3E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 4L14 11L21 4",
    stroke: "#FF8B3E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11V25.9766",
    stroke: "#FF8B3E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewGem);
export default __webpack_public_path__ + "static/media/new-gem.a655bb42bb43a6fea0d3c24714cb70fe.svg";
export { ForwardRef as ReactComponent };